import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,  
} from "react";

import styles from "../AboutBusiness/AboutBusiness.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import PopUp from "../Popup/Popup";
import Loader from "../Loader/Loader";
import Modal2 from "../Modal2/Modal2";
import {
  API_BASE_URL,
  listAgents,
  listSiteMap,
  validateWebsite,
} from "../../Store/apiStore";
import decodeToken from "../../lib/decodeToken";
import { useAgentCreator } from "../../hooks/useAgentCreator";
import useCheckAgentCreationLimit from "../../hooks/useCheckAgentCreationLimit";
import useOnboardingTracker from "../../hooks/useOnboardingTracker";
import CustomAutoSearch from "../CustomAutocomplete/CustomAutoSearch";
import filterCompanyPages from "../../utils/companyKeyboards";
const dataURLtoFile = (dataUrl, fileName = "file") => {
  const [header, base64] = dataUrl.split(",");
  const mime = header.match(/:(.*?);/)[1];
  const bytes = atob(base64);
  const buf = new Uint8Array(bytes.length);
  for (let i = 0; i < bytes.length; i++) buf[i] = bytes.charCodeAt(i);
  return new File([buf], fileName, { type: mime });
};
  
const AboutBusiness = forwardRef(
  (
    {
      onNext,
      onBack,
      onValidationError,
      onSuccess,
      onFailed,
      setLoading,
      onStepChange,
      onSiteMap,
      selectedSiteMapUrls,
      onRequestNoGMBConfirm,
      onBusinessDetailsFetched,
      onConfirmBusinessDetails,
    },
    ref
  ) => {
    const aboutBusinessForm1 = JSON.parse(
      sessionStorage.getItem("aboutBusinessForm") || "{}"
    );
    const [noGoogleListing, setNoGoogleListing] = useState(
      aboutBusinessForm1?.noGoogleListing || false
    );
    const [noBusinessWebsite, setNoBusinessWebsite] = useState(
      aboutBusinessForm1?.noBusinessWebsite || false
    );
    const [files, setFiles] = useState([]);
    const [businessUrl, setBusinessUrl] = useState("");
    const [googleListing, setGoogleListing] = useState("");
    const [aboutBusiness, setAboutBusiness] = useState("");
    const [note, setNote] = useState("");
    const [placeDetails, setPlaceDetails] = useState(null);
    //Inline error statesss
    const [businessUrlError, setBusinessUrlError] = useState("");
    const [popupType, setPopupType] = useState(null);
    const [popupMessage, setPopupMessage] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    // //const [loading, setLoading]dsfdfd = useState(false);      
    const [agentCount, setAgentCount] = useState(0);
    const HTTPS_PREFIX = "https://";
    const PREFIX_LEN = HTTPS_PREFIX.length;
    const navigate = useNavigate();
    const token = localStorage.getItem("token") || "";
    const decodeTokenData = decodeToken(token);
    const [userId, setUserId] = useState(decodeTokenData?.id || "");
    const [isVerified, setIsVerified] = useState(false);
    const [urlVerificationInProgress, setUrlVerificationInProgress] =
      useState(false);
    const [displayBusinessName, setDisplayBusinessName] = useState("");
    const sessionBusinessiD = JSON.parse(sessionStorage.getItem("bId"));
    const EditingMode = localStorage.getItem("UpdationMode");
    const [placeInfoText, setPlaceInfoText] = useState("");
    const viewSiteModal = sessionStorage.getItem("viewSiteMap");
    const [shouldFocusBack, setShouldFocusBack] = useState(false);
    const setHasFetched = true;
    const typingTimeoutRef = useRef(null);
    const inputRefWebSiteUrl = useRef(null);
    const noBusinessWebsiteRef = useRef(noBusinessWebsite);
    const listRef = useRef(null);
    const { steps, trackStep } = useOnboardingTracker();
    const [googleResults, setGoogleResults] = useState([]);
    const [showNoGMBCheckbox, setShowNoGMBCheckbox] = useState(false);
    const [userClearedWebsite, setUserClearedWebsite] = useState(false);

    useEffect(() => {
      noBusinessWebsiteRef.current = noBusinessWebsite;
    }, [noBusinessWebsite]);

    const { handleCreateAgent } = useAgentCreator({
      stepValidator: () => "AboutBusiness",
      setLoading,
      setPopupMessage,
      setPopupType,
      setShowPopup,
      navigate,
      setHasFetched,
    });

    const { isLimitExceeded, CheckingUserLimit } =
      useCheckAgentCreationLimit(userId);
    const placeDetailsExtract = JSON.parse(
      sessionStorage.getItem("placeDetailsExtract") || "{}"
    );
    const prevPlaceIdRef = useRef(null);
    const lastAutoFilledUrlRef = useRef("");
    const askParentForNoGMBConfirm = () => {
      onRequestNoGMBConfirm?.({
        onConfirm: () => {
          setNoGoogleListing(true);
          setBusinessUrl("");
          setIsVerified(false);
          setBusinessUrlError("");
          setNoBusinessWebsite(true);
          setDisplayBusinessName("");
          setGoogleResults([]);
          // CLEAR Google listing URL
          setGoogleListing("");
          // Clearr aboutBusinessForm
          const form = JSON.parse(
            sessionStorage.getItem("aboutBusinessForm") || "{}"
          );
          form.noGoogleListing = true;
          form.noBusinessWebsite = true;
          delete form.googleListing;
          delete form.businessUrl;
          sessionStorage.setItem("aboutBusinessForm", JSON.stringify(form));
          // Complletely clear GMB extracted details
          const cleared = {
            businessName: "",
            address: "",
            phone: "",
            internationalPhone: "",
            website: "",
            rating: "",
            totalRatings: "",
            hours: [],
            businessStatus: "",
            categories: [],
            aboutBusiness: "",
          };
          sessionStorage.setItem(
            "placeDetailsExtract",
            JSON.stringify(cleared)
          );
          // ALSO clear loose keys
          sessionStorage.removeItem("googleListing");
          sessionStorage.removeItem("displayBusinessName");
          sessionStorage.removeItem("businessUrl");
          sessionStorage.removeItem("websiteValidatedUrl");
          sessionStorage.removeItem("selectedSiteMapUrls");
          sessionStorage.removeItem("selectedSiteMapUrls_backup");
          sessionStorage.removeItem("urls");
          sessionStorage.removeItem("viewSiteMap");
          sessionStorage.removeItem("refreshSelectedSiteMapUrls");
        },

        onCancel: () => {
          setNoGoogleListing(false);
          setNoBusinessWebsite(false);
          const form = JSON.parse(
            sessionStorage.getItem("aboutBusinessForm") || "{}"
          );
          form.noGoogleListing = false;
          sessionStorage.setItem("aboutBusinessForm", JSON.stringify(form));
        },
      });
    };

    const normalizeWebsite = (raw) => {
      if (!raw) return "";
      try {
        let v = String(raw)
          .trim()
          .replace(/https?:\/\/(www\.)?/i, "");
        v = v.split("/")[0].toLowerCase().replace(/\s+/g, "");
        if (!v) return "";
        const domainRegex = /^[\w-]+(\.[\w-]{2,})+$/i;
        if (!domainRegex.test(v)) return "";
        return "https://" + v;
      } catch {
        return "";
      }
    };
// HY
    const initAutocomplete = () => {
      const autocomplete = new window.google.maps.places.Autocomplete(
        document.getElementById("google-autocomplete"),
        {
          types: ["establishment"],
          fields: ["place_id", "name", "url"],
        }
      );

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (place.place_id) {
          const businessUrl = place.url;
          const businessName = place.name;
          setGoogleListing(businessUrl);
          setDisplayBusinessName(businessName);
          sessionStorage.setItem("googleListing", businessUrl);
          sessionStorage.setItem("displayBusinessName", businessName);
          fetchPlaceDetails(place.place_id);
        }
      });
    };
    useEffect(() => {
      const interval = setInterval(() => {
        if (window.google?.maps?.places) {
          initAutocomplete();
          clearInterval(interval);
        }
      }, 300);
    }, []);
    const fetchPlaceDetails = (placeId) => {
      setLoading(true);

      // ✅ 1) Business change detect → purge old sitemap + url cache
      if (prevPlaceIdRef.current && prevPlaceIdRef.current !== placeId) {
        sessionStorage.removeItem("selectedSiteMapUrls");
        sessionStorage.removeItem("selectedSiteMapUrls_backup");
        sessionStorage.removeItem("urls");
        sessionStorage.removeItem("websiteValidatedUrl");
        sessionStorage.setItem("viewSiteMap", "false");

        // optional UI sync
        window.dispatchEvent(new Event("sitemapSelectionUpdated"));
      }
      prevPlaceIdRef.current = placeId;

      const service = new window.google.maps.places.PlacesService(
        document.createElement("div")
      );

      service.getDetails(
        {
          placeId,
          fields: [
            "place_id",
            "name",
            "url",
            "website",
            "formatted_address",
            "international_phone_number",
            "formatted_phone_number",
            "opening_hours",
            "rating",
            "user_ratings_total",
            "business_status",
            "types",
            "address_components",
          ],
        },
        (result, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK) {
            setPlaceDetails(result);
            generateGoogleListingUrl(result);

            const form1 = JSON.parse(
              sessionStorage.getItem("placeDetailsExtract") || "{}"
            );

            const businessData = {
              businessName: result.name || "",
              address: result.formatted_address || "",
              phone:
                result.international_phone_number ||
                result.formatted_phone_number ||
                "",
              internationalPhone: result.international_phone_number || "",
              website: result.website || "",
              rating: result.rating || "",
              totalRatings: result.user_ratings_total || "",
              hours: result.opening_hours?.weekday_text || [],
              businessStatus: result.business_status || "",
              categories: result.types || [],
              address_components: result.address_components || [],
            };

            const updatedForm = { ...form1, ...businessData };
            sessionStorage.setItem(
              "placeDetailsExtract",
              JSON.stringify(updatedForm)
            );

            const normalizedWebsite = normalizeWebsite(businessData.website);

            if (!noBusinessWebsiteRef.current) {
              if (normalizedWebsite) {
                setBusinessUrl(normalizedWebsite);
                setUserClearedWebsite(false);

                // ✅ keep aboutBusinessForm in sync
                sessionStorage.setItem("businessUrl", normalizedWebsite);
                const aboutForm = JSON.parse(
                  sessionStorage.getItem("aboutBusinessForm") || "{}"
                );
                aboutForm.businessUrl = normalizedWebsite;
                aboutForm.noBusinessWebsite = false;
                sessionStorage.setItem(
                  "aboutBusinessForm",
                  JSON.stringify(aboutForm)
                );

                // ✅ verify + sitemap (and this will set fresh default 10 later)
                handleUrlVerification(normalizedWebsite);
              } else {
                // no website for this business
                setBusinessUrl("");
                setIsVerified(false);
                setBusinessUrlError("");
                sessionStorage.removeItem("businessUrl");

                const aboutForm = JSON.parse(
                  sessionStorage.getItem("aboutBusinessForm") || "{}"
                );
                delete aboutForm.businessUrl;
                aboutForm.noBusinessWebsite = true;
                sessionStorage.setItem(
                  "aboutBusinessForm",
                  JSON.stringify(aboutForm)
                );
              }
            }

            onBusinessDetailsFetched(businessData);
            setPlaceInfoText(JSON.stringify(result, null, 2));
          } else {
            console.error("Place details fetch failed:", status);
          }

          setLoading(false);
        }
      );
    };

    const generateGoogleListingUrl = (place) => {
      const address = [
        place.address_components.find((c) => c.types.includes("street_number"))
          ?.long_name,
        place.address_components.find((c) => c.types.includes("route"))
          ?.long_name,
        place.address_components.find((c) => c.types.includes("premise"))
          ?.long_name,
        place.address_components.find((c) => c.types.includes("subpremise"))
          ?.long_name,
        place.address_components.find((c) =>
          c.types.includes("sublocality_level_1")
        )?.long_name,
        place.address_components.find((c) => c.types.includes("locality"))
          ?.long_name,
        place.address_components.find((c) =>
          c.types.includes("administrative_area_level_2")
        )?.long_name,
        place.address_components.find((c) =>
          c.types.includes("administrative_area_level_1")
        )?.long_name,
        place.address_components.find((c) => c.types.includes("postal_code"))
          ?.long_name,
      ]
        .filter(Boolean)
        .join(" ");

      const googleLink = `https://www.google.com/search?q=${encodeURIComponent(
        place.name + " " + address
      )}`;
      setGoogleListing(googleLink);
    };

    const handleUrlVerification = async (url) => {
      setUrlVerificationInProgress(true);

      try {
        const result = await validateWebsite(url);

        if (!result?.valid) {
          setIsVerified(false);
          setBusinessUrlError("Invalid URL");
          localStorage.setItem("isVerified", false);
          setUrlVerificationInProgress(false);
          if (url.trim()) setShouldFocusBack(true);
          return false;
        }

        // ✅ normalize redirect/finalUrl if API returns it
        const finalUrl = (result?.finalUrl || url || "").trim();

        setIsVerified(true);
        setBusinessUrlError("");
        localStorage.setItem("isVerified", true);

        // ✅ Always reset old selections when a new valid url is verified
        sessionStorage.removeItem("selectedSiteMapUrls");
        sessionStorage.removeItem("selectedSiteMapUrls_backup");

        sessionStorage.setItem("businessUrl", finalUrl);

        const res = await listSiteMap(finalUrl);
        let urls = res?.urls || [];

        // ensure base url exists in list (optional but useful)
        if (finalUrl && !urls.includes(finalUrl)) urls.unshift(finalUrl);

        sessionStorage.setItem("urls", JSON.stringify(urls));

        // ✅ Filter pages
        const pages = await filterCompanyPages(urls); // assuming it RETURNS filtered list
        const filteredPages = Array.isArray(pages) ? pages : urls;

        // ✅ Default select first 10
        const DEFAULT_LIMIT = 10;
        const defaultSelected = filteredPages.map((u, idx) => ({
          url: u,
          checkedStatus: idx < DEFAULT_LIMIT,
        }));

        // ✅ Save selection in sessionStorage
        sessionStorage.setItem(
          "selectedSiteMapUrls",
          JSON.stringify(defaultSelected)
        );
        sessionStorage.setItem(
          "selectedSiteMapUrls_backup",
          JSON.stringify(defaultSelected)
        );

        // ✅ UI sync for BusinessListing count
        window.dispatchEvent(new Event("sitemapSelectionUpdated"));

        sessionStorage.setItem("viewSiteMap", "true");
        setUrlVerificationInProgress(false);
        return true;
      } catch (error) {
        setIsVerified(false);
        setBusinessUrlError("Verification failed");
        localStorage.setItem("isVerified", false);
        setUrlVerificationInProgress(false);
        setShouldFocusBack(true);
        return false;
      }
    };

    useEffect(() => {
      const savedVerifiedStatus = localStorage.getItem("isVerified");
      if (savedVerifiedStatus !== null) {
        setIsVerified(savedVerifiedStatus === "true");
      }
    }, []);

    const handleBlur = (e) => {
      if (businessUrl.trim()) {
        handleUrlVerification(businessUrl);
      }
    };

    useEffect(() => {
      if (token) {
        setUserId(decodeTokenData.id || "");
      }
    }, [token]);

    useEffect(() => {
      const savedData = JSON.parse(
        sessionStorage.getItem("aboutBusinessForm") || "{}"
      );

      const storedGoogle =
        savedData.googleListing ||
        sessionStorage.getItem("googleListing") ||
        "";

      if (storedGoogle) setGoogleListing(storedGoogle);

      //  Restore checkbox states first
      if (typeof savedData.noGoogleListing === "boolean") {
        setNoGoogleListing(savedData.noGoogleListing);
      }
      if (typeof savedData.noBusinessWebsite === "boolean") {
        setNoBusinessWebsite(savedData.noBusinessWebsite);
      }

      // Only restore website URL if user *does* have a website
      if (!savedData.noBusinessWebsite && savedData.businessUrl) {
        setBusinessUrl(savedData.businessUrl);
      }

      if (localStorage.getItem("UpdationMode") == "ON") {
        if (!savedData.noBusinessWebsite && savedData.businessUrl) {
          setBusinessUrl(savedData.businessUrl);
        }

        if (savedData.aboutBusiness) setAboutBusiness(savedData.aboutBusiness);
        if (savedData.note) setNote(savedData.note);
        if (savedData.googleListing) {
          setGoogleListing(savedData.googleListing);
        }

        if (Array.isArray(savedData.files) && savedData.files.length) {
          const rebuiltFiles = savedData.files.map((d, i) =>
            dataURLtoFile(d, `file${i + 1}`)
          );
          setFiles(rebuiltFiles);
        }
      }
    }, []);

    useEffect(() => {
      if (noBusinessWebsite) {
        setBusinessUrl("");
        setIsVerified(false);
        setBusinessUrlError("");

        sessionStorage.removeItem("businessUrl");

        const form = JSON.parse(
          sessionStorage.getItem("aboutBusinessForm") || "{}"
        );
        delete form.businessUrl;
        form.noBusinessWebsite = true;
        sessionStorage.setItem("aboutBusinessForm", JSON.stringify(form));
        // ALSO CLEAR WEBSITE FROM GMB DETAILS
        const place = JSON.parse(
          sessionStorage.getItem("placeDetailsExtract") || "{}"
        );
        // place.website = "";
        sessionStorage.setItem("placeDetailsExtract", JSON.stringify(place));
      }
    }, [noBusinessWebsite]);

    useEffect(() => {
      const aboutBusinessForm = JSON.parse(
        sessionStorage.getItem("aboutBusinessForm") || "{}"
      );
      if (EditingMode == "ON") {
        const noListing =
          !aboutBusinessForm.googleListing?.trim() && !googleListing?.trim();
        const noWebsite =
          !aboutBusinessForm.businessUrl?.trim() && !businessUrl?.trim();

        if (noListing) {
          setNoGoogleListing(true);
          aboutBusinessForm.noGoogleListing = true;
          sessionStorage.setItem(
            "aboutBusinessForm",
            JSON.stringify(aboutBusinessForm)
          );
        }

        if (noWebsite) {
          setNoBusinessWebsite(true);
          setIsVerified(true);
          aboutBusinessForm.noBusinessWebsite = true;
          sessionStorage.setItem(
            "aboutBusinessForm",
            JSON.stringify(aboutBusinessForm)
          );
        }
      } else {
        if (aboutBusinessForm.noGoogleListing === true) {
          setNoGoogleListing(true);
        } else {
          setNoGoogleListing(false);
        }

        if (aboutBusinessForm.noBusinessWebsite === true) {
          setNoBusinessWebsite(true);
          setIsVerified(true);
        } else {
          setNoBusinessWebsite(false);
        }
      }
    }, [googleListing, businessUrl]);
    const fetchAgentCountFromUser = async () => {
      try {
        const response = await listAgents();
        const filterAgents = await response.filter(
          (res) => res.userId === userId
        );
        setAgentCount(filterAgents.length);
      } catch (error) {
        console.log(error);
      }
    };
    const handleContinue = () => {
      const finalBusinessUrl = noGoogleListing ? "" : businessUrl;
      const finalGoogleListing = noGoogleListing ? "" : googleListing;

      const payload = {
        businessUrl: finalBusinessUrl,
        googleListing: finalGoogleListing,
        aboutBusiness,
        note,
        noGoogleListing,
        noBusinessWebsite: noGoogleListing ? true : noBusinessWebsite,
      };

      sessionStorage.setItem("aboutBusinessForm", JSON.stringify(payload));
      sessionStorage.setItem("businessUrl", businessUrl || "");

      onStepChange?.(4);

      trackStep({
        stepName: "public_listing_select",
        stepNo: 3,
        screenName: "Public Listing",
        email: localStorage.getItem("userEmail"),
        userId: decodeToken(localStorage.getItem("token"))?.id || null,
        data: {
          ...payload,
          businessDetails: placeDetailsExtract,
        },
      });
    };

    const confirmSkip = () => {
      setShowPopup(false);
      navigate("/steps");
    };
    const fetchGoogleResults = (text) => {
      if (!window.google || !window.google.maps || !window.google.maps.places)
        return;

      if (!text) {
        setGoogleResults([]);
        return;
      }

      const service = new window.google.maps.places.AutocompleteService();
          service.getPlacePredictions({ input: text, types: ['establishment'] }, (predictions) => {
        setGoogleResults(predictions || []);
      });
    };
    useEffect(() => {
      const savedDisplayBusinessName = sessionStorage.getItem(
        "displayBusinessName"
      );

      if (savedDisplayBusinessName) {
        setDisplayBusinessName(savedDisplayBusinessName);
        setShowNoGMBCheckbox(true);
      }

      const savedNoGoogle = JSON.parse(
        sessionStorage.getItem("aboutBusinessForm") || "{}"
      )?.noGoogleListing;

      if (savedNoGoogle === true) {
        setShowNoGMBCheckbox(true);
      }
    }, []);

    useEffect(() => {
      fetchAgentCountFromUser();
    }, []);

    useEffect(() => {
      if (!CheckingUserLimit && isLimitExceeded && !EditingMode) {
        setShowPopup(true);
        setPopupType("failed");
        setPopupMessage(
          "Agent creation limit exceeded. Please upgrade your plan!"
        );
      }
    }, [CheckingUserLimit, isLimitExceeded]);
    useEffect(() => {
      const interval = setInterval(() => {
        if (window.google?.maps?.places) {
          const input = document.getElementById("google-autocomplete");
          if (input) {
            initAutocomplete();
            clearInterval(interval);
          }
        }
      }, 300);
    }, []);
    // if (CheckingUserLimit) return;
    const handleClosePopup = () => {
      if (!CheckingUserLimit && isLimitExceeded && !EditingMode) {
        navigate("/fast-agent-detail");
        setShowPopup(false);
      } else {
        setShowPopup(false);
      }
    };
    //Using Error Handling
    useImperativeHandle(ref, () => ({
      validate: () => {
        let hasError = false;

        const isGoogleListingValid = (
          googleListing ||
          sessionStorage.getItem("googleListing") ||
          ""
        ).trim();

        if (!isGoogleListingValid && !noGoogleListing) {
          onValidationError?.({
            type: "failed",
            message:
              "Please provide a Google Listing or check the box if you don't have one.",
          });
          hasError = true;
        }

        return !hasError;
      },

      save: async () => {
        handleContinue();
      },
    }));
    useEffect(() => {
      if (businessUrl.length <= 8) {
        setShouldFocusBack(false);
        return;
      }

      if (shouldFocusBack) {
        inputRefWebSiteUrl.current?.focus();
        setShouldFocusBack(false);
      }
    }, [shouldFocusBack, businessUrl]);
    useEffect(() => {
      if (noBusinessWebsite) return;

      const place = JSON.parse(
        sessionStorage.getItem("placeDetailsExtract") || "{}"
      );
      if (!businessUrl && place?.website) {
        const normalized = normalizeWebsite(place.website);
        if (normalized) {
          setBusinessUrl(normalized);
          // immediately verify the prefilled url
          handleUrlVerification(normalized);
        }
      }
    }, []);

    useEffect(() => {
      if (noBusinessWebsite) return;
      if (!placeDetails?.website) return;

      if (userClearedWebsite) return;

      const normalized = normalizeWebsite(placeDetails.website);
      if (normalized && (!businessUrl || businessUrl === HTTPS_PREFIX)) {
        setBusinessUrl(normalized);
        setUserClearedWebsite(false); // programmatic set → manual clear flag hata do
        handleUrlVerification(normalized);
      }
    }, [placeDetails, noBusinessWebsite]);
    const scrollListIntoView = () => {
      if (listRef.current) {
        listRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    };
    useEffect(() => {
      if (noGoogleListing) {
        setShowNoGMBCheckbox(true);
      }
    }, [noGoogleListing]);
    useEffect(() => {
      if (displayBusinessName?.trim().length > 0) {
        setShowNoGMBCheckbox(true);
      } else {
        if (!noGoogleListing) setShowNoGMBCheckbox(false);
      }
    }, [displayBusinessName, noGoogleListing]);
// new
    return (
      <>
        <div>
          <div className={styles.container}>
            <div className={styles.header}></div>
            <form className={styles.formContainer}>
              <div className={styles.form}>
                <div>
                  <CustomAutoSearch
                    value={displayBusinessName}
                    placeholder="Type the name of your Business to Search"
                    disabled={noGoogleListing}
                    required={true}
                    results={googleResults}
                    fetchResults={fetchGoogleResults}
                    onChange={(value) => {
                      setDisplayBusinessName(value);
                      setShowNoGMBCheckbox(value.trim().length > 0);
                      fetchGoogleResults(value);
                      setTimeout(scrollListIntoView, 300);
                    }}
                    onFocus={() => setTimeout(scrollListIntoView, 300)}
                    onClick={() => setTimeout(scrollListIntoView, 300)}
                    onSelect={(item) => {
                      setShowNoGMBCheckbox(true);

                      const name =
                        item?.structured_formatting?.main_text ||
                        item?.description ||
                        "";

                      setDisplayBusinessName(name);
                      setGoogleResults([]);

                      sessionStorage.setItem("showNoGMBCheckbox", "true");
                      sessionStorage.setItem("displayBusinessName", name);

                      const googleLink = `https://www.google.com/search?q=${encodeURIComponent(
                        item.description
                      )}`;

                      setGoogleListing(googleLink);
                      sessionStorage.setItem("googleListing", googleLink);

                      // ✅ IMPORTANT: persist into aboutBusinessForm also
                      const form = JSON.parse(
                        sessionStorage.getItem("aboutBusinessForm") || "{}"
                      );
                      form.googleListing = googleLink;
                      form.noGoogleListing = false;
                      sessionStorage.setItem(
                        "aboutBusinessForm",
                        JSON.stringify(form)
                      );

                      fetchPlaceDetails(item.place_id);
                    }}
                  />
                  {showNoGMBCheckbox && (
                    <div
                      className={styles.checkboxRow}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                    >
                      <input
                        id="no-google-listing"
                        type="checkbox"
                        className={styles.customCheckbox}
                        checked={noGoogleListing}
                        onChange={(e) => {
                          const checked = e.target.checked;

                          if (checked) {
                            askParentForNoGMBConfirm();
                          } else {
                            setNoGoogleListing(false);
                            setNoBusinessWebsite(false); // ✅ add

                            const form = JSON.parse(
                              sessionStorage.getItem("aboutBusinessForm") ||
                                "{}"
                            );
                            form.noGoogleListing = false;
                            form.noBusinessWebsite = false;
                            sessionStorage.setItem(
                              "aboutBusinessForm",
                              JSON.stringify(form)
                            );
                          }
                        }}
                      />
                      <label htmlFor="no-google-listing">
                        My business is not listed here.
                      </label>
                    </div>
                  )}
                </div>
              </div>
            </form>
          </div>
          {showPopup && (
            <PopUp
              type={popupType}
              onClose={() => handleClosePopup()}
              message={popupMessage}
              onConfirm={confirmSkip}
            />
          )}
        </div>
      </>
    );
  }
);

export default AboutBusiness;
